import Suono from '../assets/img/suono.jpg';
import Eule from '../assets/img/eule.png';
import Bystress from '../assets/img/byestress.jpg';
import Adttendance from '../assets/img/attendance.jpg';
import Building from '../assets/img/building.jpg';
import Clust from '../assets/img/clustering.jpg';
import Sound from '../assets/img/sound.jpg';
import Cat from '../assets/img/galleta.jpg';
import Moix from '../assets/img/moix.png';


export const Project = [
    {
        id:0,
        title:'Song prediction + recommendation',
        description: 'Machine Learning',
        longdescription: 'Predicting song popularity and recommending songs based on audio features',
        image:Sound,
        techs:{
            name:'Python',
            name1: 'Pandas, Numpy, Scikit-learn'
        },
        adinfo:'',
        link:'https://github.com/julianaquin/Machine_Learning-UCA_Projects/blob/main/ML_2024_25_Spotify_project.ipynb'
    },
    {
        id:1,
        title:'Pet Adoptability',
        description: 'Machine Learning',
        longdescription: 'Predicting the adoptability of pets using machine learning',
        image:Cat,
        techs:{
            name:'Python',
            name1: 'Pandas, Numpy, Matplotlib'
        },
        adinfo:'',
        link:'https://github.com/julianaquin/Machine_Learning-UCA_Projects/blob/main/Pet_Adoptability_ML2_project.ipynb'
    },
    {
        id:2,
        title:'Attendance: Face recognition',
        description: 'Deep Learning',
        longdescription: 'Filling an attendance sheet using group photos and identifying individuals',
        image:Adttendance,
        techs:{
            name:'Python',
            name1: 'Pytorch, YOLO, numpy, pandas, matplotlib, ViT'
        },
        adinfo:'',
        link:'https://github.com/julianaquin/Deep_Learning-UCA_Projects/blob/main/DL_Attendance_Face_Recognition.pdf'
    },
    {
        id:3,
        title:'Clustering segmentation comparison',
        description: 'Machine Learning',
        longdescription: 'KMeans and GMM clustering algorithms applied to three datasets to compare how they performe segmentation',
        image: Clust,
        techs:{
            name:'Python',
            name1: 'Pandas, Numpy, Scikit-learn'
        },
        adinfo:'',
        link:'https://github.com/julianaquin/Clustering-for-Segmentation'
    },
    {
        id:4,
        title:'Energy Consumption Prediction',
        description: 'Machine Learning',
        longdescription: 'Predicting energy consumption of buildings regarding building characteristics and meteorological data',
        image:Building,
        techs:{
            name:'Python',
            name1: 'Pandas, Numpy, Matplotlib, Scikit-learn'
        },
        adinfo:'',
        link:'https://github.com/julianaquin/Machine_Learning-UCA_Projects/blob/main/Machine_Learning_Project.ipynb'
    },    
    {
        id:5,
        title:'Byestress',
        description: 'Web development',
        longdescription: 'Programming and design of a health website',
        image:Bystress,
        techs:{
            name:'React',
            name1: 'CSS, HTML, Javascript'
        },
        adinfo:'https://github.com/julianaquin/byestress',
        link:'https://byestress.netlify.app/'
    },
    {
        id:6,
        title:'Eule',
        description: 'App development',
        longdescription: 'App for donating study supplies',
        image: Eule,
        techs:{
            name:'Android Studio',
            name1: 'Java, Illustrator, Photoshop'
        },
        adinfo:'',
        link:'https://www.behance.net/gallery/58434185/Eule'
    },
     {
        id:7,
        title:'Moix',
        description: 'UX/UI design',
        longdescription: 'Fashion website design',
        image: Moix,
        techs:{
            name:'Illustrator',
            name1: 'Photoshop'
        },
        adinfo:'',
        link:'https://www.behance.net/gallery/79223899/Moix-web-page'
    },
    {
        id:8,
        title:'Suono',
        description: 'UX/UI design',
        longdescription: 'Design of a music streaming website',
        image:Suono,
        techs:{
            name:'Illustrator',
            name1: 'Photoshop'
        },
        adinfo:'',
        link:'https://www.behance.net/gallery/142883311/Suono-Streaming-site'
    }
]